import React, { useState } from "react";
import FormEntry from "../FormEntry";
import Chart from "../Chart";
import { getListPartnerName } from "components/ListPartner";
import {
  formatNumber,
  getTitleDecoration,
  formatSimpleDate,
  getDayOfDate,
} from "utils/common";

const CardEntry = ({ entry, setEntrySetting, openModal }) => {
  const [show, setShow] = useState(false);
  const OpenModalPartner = () => {
      setEntrySetting(entry);
      openModal("modal-partner");
  };

  return (
    <div className={`content-box mb-2 ${show ? "active" : ""}`}>
      <div className="label">
        <div className="fw-600 bg-white">
          <div className="py-2 px-2 px-md-3">
            <div className="row gx-0 item-1">
              <div className="w-entries-1 fs-16 fs-sm-14 pe-2">
                <span
                  dangerouslySetInnerHTML={{
                    __html: getTitleDecoration(
                      entry?.title_decoration?.title_decoration_content
                    ),
                  }}
                ></span>
                {entry?.title_login}
              </div>
              <div className="w-entries-2 border-color-black py-entry text-center fs-12 align-self-start">
                {formatNumber(entry?.point, 6)}
                <span className="ms-1 fs-9 d-block d-md-inline-block">
                  ポイント
                </span>
              </div>
            </div>
            <div className="row gx-0 mt-2 mt-md-1 mb-2 mb-md-1 item-2 position-relative align-items-center">
              <div className="w-entries-4 fs-12 text-end">
                応募日 ：
                {entry?.apply_date && (
                  <span>
                    {formatSimpleDate(entry?.apply_date)}(
                    {getDayOfDate(entry?.apply_date)})
                  </span>
                )}
              </div>
              <div className="w-entries-4 align-self-start text-start text-md-end">
                {(!entry.lock_partnership && entry.partner_flg === 1 ) && (
                  <div
                    onClick={OpenModalPartner}
                    className={`btn-clap-app green me-2`}
                  >
                    同行者の確認・変更
                  </div>
                )}
                <a
                  className="w-entries-2 z-index-3 bg-red-light rounded-pill text-white fs-13 fs-sm-11 text-center py-1"
                  href={"entries/detail/" + entry?.promotion_id }
                >
                  案件内容
                </a>
              </div>
              
            </div>
          </div>
          <div className="highlight">
            現在のステップ : {entry?.step_name}
          </div>
          <div className="mt-2">
            {entry.promotion_sets.map((p) => {
                return (
                  <div key={p.id} className="my-2 fw-600 fs-13">
                    {entry.split_flg === 1 && 
                    <div className="bg-violet px-2 py-1 fs-sm-12">{p.name}</div>}
                    {entry.partner_flg === 1 && 
                    <div className="bg-pink px-2 py-1 py-1 fs-sm-9">
                      同行者：{getListPartnerName(p.id, entry.partnerships)}
                    </div>}
                    
                  </div>
                );
            })}
          </div>
          <div className="mt-2 d-flex align-items-center justify-content-center">
          </div>
        </div>

        <div className="label-footer py-2" onClick={() => setShow(!show)}>
          <span className="icon-rotate me-2">
            <svg
              width="17"
              height="8"
              viewBox="0 0 17 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.80006 4.79778L15.0302 0.158203L16.1104 1.84145L7.75685 7.20187L0.000324206 1.8215L1.14024 0.178151L7.80006 4.79778Z"
                fill="white"
              />
            </svg>
          </span>
          <div>ステップ詳細</div>
        </div>
      </div>
      <div className="content-body">
        <div className="d-flex flex-wrap p-0 p-lg-3">
          <div className="content-chart position-relative text-center">
            <Chart item={entry} />
          </div>

          <div className="content-main p-3 py-0">
            <div
              className="html-design-table my-2"
              dangerouslySetInnerHTML={{ __html: entry.step_description }}
            ></div>
            <FormEntry
              item={entry}
              openFn={openModal}
              setEntrySetting={setEntrySetting}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardEntry;
